import {
  QueryConstraint,
  Unsubscribe,
  getDocs,
  query,
  where,
  writeBatch,
} from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class StoreMonitorOrdersDB extends FirestorePipe {
  public static readonly colName = "MonitorOrders";

  constructor(idEstab: string, idStore: string) {
    if (!idEstab) throw new Error("Informe o id do estabelecimento");
    super(
      `${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${StoreMonitorOrdersDB.colName}`
    );
  }

  public define(id: string, data: any): Promise<any> {
    return this._define(id, data);
  }

  public create(data: any): Promise<any> {
    return this._create(data);
  }

  public update(id: string, data: any): Promise<any> {
    return this._update(id, data);
  }

  public delete(id: string): Promise<any> {
    return this._delete(id);
  }

  public getAll(...params: QueryConstraint[]): Promise<any[]> {
    return this._getAll<any>(...params);
  }

  public get(id: string): Promise<any> {
    return this._get(id);
  }

  public on(
    listener: (data: any[]) => void,
    ...params: QueryConstraint[]
  ): Unsubscribe {
    return this._on(listener, ...params);
  }


  public async deleteByMonitorId(monitorId: string): Promise<void> {
    const docs = await this.getAll(where("monitorId", "==", monitorId));
    if (docs.length === 0) return;
    const deletePromises = docs.map(doc => this.delete(doc.id));
    await Promise.all(deletePromises);
  }
  
  
}

export default StoreMonitorOrdersDB;
